import type {
  CartResponse,
  CartItem,
  AddToCartDto,
  UpdateCartItemDto,
  CartValidationResult,
} from '@printtat/shared';
import { apiFetch, apiJson } from '@/lib/apiFetch';

export const cartApi = {
  async getCart(): Promise<CartResponse> {
    return apiJson<CartResponse>('/cart');
  },

  async addToCart(dto: AddToCartDto): Promise<CartItem> {
    return apiJson<CartItem>('/cart', { method: 'POST', body: dto });
  },

  async updateQuantity(id: string, quantity: number): Promise<CartItem> {
    return apiJson<CartItem>(`/cart/${id}`, {
      method: 'PATCH',
      body: { quantity } satisfies UpdateCartItemDto,
    });
  },

  async removeItem(id: string): Promise<void> {
    const res = await apiFetch(`/cart/${id}`, { method: 'DELETE' });
    if (!res.ok) throw new Error('Failed to remove item');
  },

  async clearCart(): Promise<void> {
    const res = await apiFetch('/cart', { method: 'DELETE' });
    if (!res.ok) throw new Error('Failed to clear cart');
  },

  async validate(): Promise<CartValidationResult> {
    return apiJson<CartValidationResult>('/cart/validate', { method: 'POST' });
  },
};
